import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Button } from 'antd';
import DetailItem from '../../../../CSIComponents/DetailItem';
import ReadOnlyTextarea from '../../../../CSIComponents/ReadOnlyTextarea';
import PageContainer from '../../../../CSIComponents/PageContainer';

interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any,
    setOperationType: void | any,
    detailData: any
}
const AMOUNT = 'Amount';
const PERCENT = 'Percent';
const NIGHTS = 'Nights';
const CommissionDetail = (props: propsTypes) => {
    const translateBoolean = (type: string) => type === 'true' ? 'Yes' : (type === 'false' ? 'No' : '')
    const [detailData, setDetailData] = useState<{ label?: string, value?: string, span: number }[]>([]);
    let _detailData = [
        { label: 'Commission Type', value: props?.detailData?.policies?.commissionpolicy?.type, span: 6 },
        { span: 6 },
        { span: 6 },
        { label: 'Description', value: props?.detailData?.policies?.commissionpolicy?.description, span: 18 },
        { span: 6 },
        { label: 'Payment Company', value: props?.detailData?.policies?.commissionpolicy?.paymentcompany, span: 6 },
        { label: 'Commission Settled Via HCC', value: translateBoolean(props?.detailData?.policies?.commissionpolicy?.commissionhcc), span: 6 },
        { label: 'Commission Inclusive of Tax', value: translateBoolean(props?.detailData?.policies?.commissionpolicy?.taxinclusive), span: 6 },
    ]

    useEffect(() => {
        if (props?.detailData?.policies?.commissionpolicy?.type === AMOUNT) {
            _detailData[1] = { label: 'Charge (Amount)', value: props?.detailData?.policies?.commissionpolicy?.charge, span: 6 }
            _detailData[2] = { label: 'Currency', value: props?.detailData?.policies?.commissionpolicy?.currency, span: 6 }
        } else if (props?.detailData?.policies?.commissionpolicy?.type === PERCENT) {
            _detailData[1] = { label: 'Charge (Percent)', value: props?.detailData?.policies?.commissionpolicy?.charge, span: 6 }
        } else if (props?.detailData?.policies?.commissionpolicy?.type === NIGHTS) {
            _detailData[1] = { label: 'Charge (Night)', value: props?.detailData?.policies?.commissionpolicy?.charge, span: 6 }
        }
        setDetailData(_detailData)
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])

    return (
        <PageContainer>
            <Card 
            style={{ marginTop: -15 }} 
            title="Commission" 
            headStyle={{ fontWeight: 600, fontSize: 14, color: '#333', paddingTop: '8px' }}
            extra={<Button type="primary" className="db-edit-btn" onClick={() => { props.isEditable(); props.setOperationType('edit') }}>Edit</Button>}
            >
                <div style={{ padding: "0 20px" }}>
                    <Row gutter={24}>
                        {detailData.length !== 0 && detailData.map((item, i) => {
                            return (
                                <React.Fragment key={i}>
                                    {
                                        item.label ? <>
                                            {
                                                item.label === 'Description' ?
                                                    <Col span={item.span} key={i} className="col-margin">
                                                        <ReadOnlyTextarea value={item.value} label={item.label} />
                                                    </Col> : <Col span={item.span} key={i} className="col-margin">
                                                        <DetailItem value={item.value} label={item.label} style={{}} />
                                                    </Col>}
                                        </> : <Col span={item.span} key={i}></Col>
                                    }
                                </React.Fragment>
                            )
                        })
                        }
                    </Row>
                </div>
            </Card>
        </PageContainer>
    )
}

export default CommissionDetail;



